import { useTranslation } from 'react-i18next';
import PaginaTexto from '../Compartido/PaginaTexto.jsx';
import urlLogo from '../Compartido/urlLogo.js';

const TextosEdificio = ({ texto, ruta, lang, config }) => {

    const { t } = useTranslation();

    const imagen = texto.fotos_ota.length > 0
        ? ruta + "/edificios/" + texto.id + "/fotos/ota/" + texto.fotos_ota[0].nombre
        : null;

    return (
        <PaginaTexto
            titulo={texto.nombre}
            eyebrow={t("Edificio")}
            imagen={imagen}
            logo={urlLogo(config, ruta)}
            html={texto.descripcion[lang]}
        />
    );
}

export default TextosEdificio;
